import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { X } from "lucide-react";
import { useAppSelector } from "@/app/hooks";
import { sessionSelector } from "@/features/sessionSlice";
import { Button } from "./ui/button";
export default function NotificationPrompt() {
    const { user } = useAppSelector(sessionSelector);
    const [open, setOpen] = useState(false);
    const [previousPermission, setPreviousPermission] = useState(null);
    if (!user?.confirmedAt) {
        return null;
    }
    if (Notification.permission === "default" && previousPermission !== Notification.permission) {
        setPreviousPermission(Notification.permission);
        setOpen(true);
    }
    const requestPermission = async () => {
        const result = await Notification.requestPermission();
        if (result !== "default") {
            setOpen(false);
        }
    };
    if (!open) {
        return null;
    }
    return (_jsx("div", { className: "fixed bottom-0 left-0 right-0 z-50 border-t bg-background px-4 py-3 shadow-lg", children: _jsxs("div", { className: "mx-auto flex max-w-screen-xl items-center justify-between gap-4", children: [_jsx("p", { className: "text-sm", children: "\uD83D\uDD14 Um alle Funktionen in vollem Umfang nutzen zu k\u00F6nnen, m\u00FCssen Benachrichtigungen aktiviert werden." }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Button, { size: "sm", onClick: requestPermission, children: "Benachrichtigungen aktivieren" }), _jsxs(Button, { variant: "ghost", size: "icon", className: "h-8 w-8", onClick: () => setOpen(false), children: [_jsx(X, { className: "h-4 w-4" }), _jsx("span", { className: "sr-only", children: "Schlie\u00DFen" })] })] })] }) }));
}
